import styles from "./LeftSection.module.scss";
import PropertyTopSection from "../PropertyTopSection";
import OffersSection from "../OffersSection";
import PropertyAbout from "../PropertyAboutSection";
import VirtualTourConnectSection from "../VirtualTourConnectSection";
import AmenitiesSection from "../AmenitiesSection";
import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import SectionRegionInfo from "@Pages/Search/components/SectionRegionInfo";
import RoomTypeContextProvider from "../RoomTypeSection/context";
import { LocationProvider } from "../MapSection/locationContext";
import { lazy } from "react";
import SectionFeaturedDesktop from "../SectionFeaturedDesktop";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import NextRoomButton from "../NextRoomButton";
import SimilarPropertiesWrapper from "@Pages/Search/components/SimilarProperties/SimilarPropertiesWrapper";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";
import RoomTypeSectionDynamicDesktop from "../RoomTypeSection/RoomTypeSectionDynamicDesktop";
import VideoSection from "../VideoSection";
import loadable from "@loadable/component";
import FullPageLoader from "@Components/FullPageLoader";
import HouseRules from "../HouseRules";
import PaymentAndFees from "../PaymentAndFees";
import MeetTheResidents from "../MeetTheResidents";
import FloorPlansSection from "../FloorPlansSection";

const SectionInternal = loadable(() => import("../AgentView/SectionInternal"), {
  fallback: <FullPageLoader />,
});
const MapLocation = lazy(() => import("../MapSection"));

const LeftSection = ({ isLoading = false, isMapSectionV2 = false, isAgentView = false }) => {
  const { isWhitelabel, isUniversityPartner, isAllowedEmail } = useWhitelabel();
  const isBookFormEnabledForInactiveProperty = useFeatureIsOn(
    GROWTH_BOOK_FEATURE_FLAG_NAMES.ENABLE_BOOK_FORM_FOR_INACTIVE_PROPERTY,
  );

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.section}>
          <SectionFeaturedDesktop
            isLoading={isLoading}
            isBookFormEnabledForInactiveProperty={isBookFormEnabledForInactiveProperty}
          />
          <PropertyTopSection isDesktop loading />
        </div>
      </div>
    );
  }

  return (
    <RoomTypeContextProvider isLoading={isLoading}>
      <div className={styles.container}>
        <div className={styles.section}>
          <SectionFeaturedDesktop
            isLoading={isLoading}
            isBookFormEnabledForInactiveProperty={isBookFormEnabledForInactiveProperty}
          />
          <PropertyTopSection isDesktop />
        </div>
        {!isLoading && (
          <>
            {isAgentView ? <SectionInternal /> : <></>}
            <SimilarPropertiesWrapper isTopSection />
            {(!isWhitelabel || isUniversityPartner || isAllowedEmail) && (
              <OffersSection isDesktop isAgentView={isAgentView} />
            )}
            <PropertyAbout isDesktop />
            <VideoSection />
            <AmenitiesSection isDesktop />
            <RoomTypeSectionDynamicDesktop isDesktop />
            <NextRoomButton />
            <HouseRules isDesktop />
            <PaymentAndFees isDesktop />
            <FloorPlansSection isDesktop />
            <MeetTheResidents isDesktop />
            <SectionRegionInfo includeFields={["inventoryFaqs"]} isDesktop defaultFirstOpen />

            {!isMapSectionV2 && (
              <>
                <LocationProvider>
                  <LazyLoadOnScroll fallback={<section style={{ height: "340px" }} id="map" />}>
                    <MapLocation isDesktop />
                  </LazyLoadOnScroll>
                </LocationProvider>
                <VirtualTourConnectSection />
              </>
            )}
          </>
        )}
      </div>
    </RoomTypeContextProvider>
  );
};

export default wrapperHOC(LeftSection, {
  componentName: "LeftSectionDesktop-PropertyPage",
  showForChina: true,
});
